import Vue from "vue";
import { SUBSCRIPTION_DURATIONS } from "@/enum/subscription_duration";
import i18n from "@/i18n";

Vue.filter("subscription_duration", (value, amount = null) => {
  let subscription_duration = SUBSCRIPTION_DURATIONS.find(x => x.key === value);
  if (!subscription_duration) {
    return null;
  }

  return i18n.tc(
    subscription_duration.translation_key,
    amount !== null ? amount : 1
  );
});
